import { render } from "./subPostList.vue?vue&type=template&id=a9de2208&scoped=true"
import script from "./subPostList.vue?vue&type=script&lang=js"
export * from "./subPostList.vue?vue&type=script&lang=js"

import "./subPostList.vue?vue&type=style&index=0&id=a9de2208&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9de2208"

export default script